// TODO the constants here should ideally be pulled from environment variables rather than hard-coded
const env = {
    clientIds: {
        blizzard: {
            us: 'fa9b33c953d549c58b028e3e588f533e',
            eu: 'e9332d2f25554b959db636ad0bdd3ba8',
            kr: '2988c38da1c84c5d863f5f3fb353dce0',
            tw: '6d2077e92c6a48628d2de41b1cd50aaa'
        },
        patreon: 'gr7cvE6qR49wbH_xp6oUiKfSb1IhdED9cb1Wc6VDvZ82HZuwogORfh5-T17mxgjg',
        twitch: 'ffd4lf57uy229os2p5ybszs74c2dlu'
    }
};

export default env;